import React from "react";
import { Box } from "@mui/material";
import styles from "./BabySizeImageCard.module.scss";
import CustomSkeleton from "../../components/custom-skeleton/CustomSkeleton";

const BabySizeImageCardSkeleton: React.FC = () => {
  return (
    <Box className={styles.babySizeImageWidgetContainer}>
      {/* Title */}
      <CustomSkeleton variant="text" width="100%" height={32} />

      {/* Subtitle */}
      <CustomSkeleton variant="text" width="60%" height={24} style={{ marginTop: 16 }} />

      {/* Images */}
      <Box className={styles.babySizeImages} style={{ marginTop: 24 }}>
        <CustomSkeleton
          variant="circular"
          width={180}
          height={180}
          className={styles.imageBackground}
        />
      </Box>

      {/* Button */}
      <Box className={styles.buttonContainer} style={{ marginTop: 24 }}>
        <CustomSkeleton variant="rectangular" width={100} height={40} />
      </Box>
    </Box>
  );
};

export default BabySizeImageCardSkeleton;
